<script>
    import * as m from '@app/paraglide/messages.js';
    import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { editorState } from "@app/store/editorStore.svelte.js";
    import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
    import autoFormat from "@cclib/functions/eventGroups/autoFormat.js";
    import _Event from "@cclib/classes/event.js";
    import insertEvent from "@cclib/functions/eventGroups/insertEvent.js";
    import Swal from "sweetalert2";
    import { SWAL_BASE, SWAL_CLASSES } from "@app/lib/swalClasses.js";

    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    function pasteEvents() {
        try {
            navigator.clipboard.readText().then((text) => {
                try {
                    let clipboardEvents = JSON.parse(text);
                    //check if clipboardEvents is actually subtitle events
                    if (
                        clipboardEvents.length > 0 &&
                        clipboardEvents[0].id &&
                        clipboardEvents[0].style
                    ) {
                        let currentTime = player ? player.currentTime : 0;
                        let newCurrentTime = currentTime;
                        Swal.fire({
                            ...SWAL_BASE,
                            customClass: SWAL_CLASSES.confirmCancel,
                            title: m.context_menu_paste_title(),
                            text: m.context_menu_paste_text(),
                            icon: "question",
                            showCancelButton: true,
                            confirmButtonText: m.context_menu_paste_confirm(),
                            cancelButtonText: m.context_menu_paste_cancel()
                        })
                            .then((sAlertRes) => {
                                clipboardEvents.forEach(
                                    (event, count, events) => {
                                        // Use Sweet Alert to ask the user if they wish to paste events at the current Time. If yes, then paste the events, but update the start and end time of the event so that the start time is the current time and the end time is the current time + the duration of the event.
                                        if (
                                            sAlertRes.isConfirmed &&
                                            currentTime >= 0
                                        ) {
                                            let duration =
                                                event.end - event.start;
                                            let startTime =
                                                count === 0
                                                    ? currentTime
                                                    : currentTime +
                                                      (event.start -
                                                          events[0].end);

                                            startTime = startTime
                                                ? startTime
                                                : newCurrentTime;
                                            let endTime = startTime + duration;
                                            newCurrentTime = endTime;
                                            eventGroupState[
                                                projectState.selected
                                            ] = insertEvent(
                                                eventGroupState[
                                                    projectState.selected
                                                ],
                                                {
                                                    ...event,
                                                    start: startTime,
                                                    end: endTime,
                                                },
                                                eventGroupState[
                                                    projectState.selected
                                                ].selected[0] +
                                                    count +
                                                    1,
                                            );
                                        } else {
                                            eventGroupState[
                                                projectState.selected
                                            ] = insertEvent(
                                                eventGroupState[
                                                    projectState.selected
                                                ],
                                                event,
                                                eventGroupState[
                                                    projectState.selected
                                                ].selected[0] +
                                                    count +
                                                    1,
                                            );
                                        }                                        
                                    }
                                );
                            })
                            .catch((err) => {
                                console.log("Error pasting events");
                                console.log(err);
                                console.log(err.message);
                            });
                    } else {
                        throw new Error("No events found in clipboard");
                    }
                } catch (err) {
                    let range = window?.quillEditor?.getSelection();
                    if (range && range.length === 0) {
                        window.quillEditor.insertText(range.index, text);
                    } else if (range) {
                        window.quillEditor.deleteText(range.index, range.length);
                        window.quillEditor.insertText(range.index, text);
                    }

                    if (
                        editorState.autoFormatText &&
                        eventGroupState[projectState.selected].selected
                            .length > 0
                    ) {
                        let maxLines = eventGroupState[projectState.selected]
                                ? eventGroupState[projectState.selected]
                                      .maxLines
                                : 2,
                            maxChars = eventGroupState[projectState.selected]
                                ? eventGroupState[projectState.selected]
                                      .maxChars
                                : 32,
                            minDuration = 0,
                            allowOrphanWords = true;

                        try {
                            let selectedEvent =
                                eventGroupState[projectState.selected]
                                    .selected[0];
                            eventGroupState[projectState.selected].selected =
                                [selectedEvent];

                            eventGroupState[projectState.selected] =
                                autoFormat(
                                    eventGroupState[projectState.selected],
                                    maxLines,
                                    maxChars,
                                    minDuration,
                                    allowOrphanWords,
                                    eventGroupState[projectState.selected]
                                        .selected,
                                );

                            eventGroupState[projectState.selected].selected =
                                [];
                            setTimeout(() => {
                                eventGroupState[
                                    projectState.selected
                                ].selected = [selectedEvent];
                            }, 50);
                        } catch (err) {
                            console.log(err.message);
                        }
                    }
                }

                insertHistoryAction({
                    name: "paste events", //action name
                    eventGroup: projectState.selected,
                    snapshots: [
                        {
                            store: "eventGroupState",
                            value: JSON.stringify(eventGroupState),
                        },
                    ],
                });

                
            });
        } catch (err) {
            console.log(err);
            console.log(err.message);
        } finally {
            dispatch("done");
        }
    }
</script>

<a
    id="pasteEventsBtn"
    class="dropdown-item"
    role="button"
    aria-label={m.context_menu_paste_label()}
    href="#!/"
    onclick={pasteEvents}>
    {m.context_menu_paste()}
</a>
